"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DedustApi = void 0;
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable max-len */
const axios_1 = __importDefault(require("axios"));
class DedustApi {
    constructor() {
        this._url = 'https://api.dedust.io/v2';
    }
    async send(url, data) {
        const apiUrlToUse = this._url;
        const res = await axios_1.default.get(`${apiUrlToUse}${url}`);
        if (res.data.error) {
            console.error(res.data.result);
            return undefined;
        }
        return res.data;
    }
    async getAssets() {
        const data = await this.send('/assets', {});
        console.log(data);
        return data;
    }
}
exports.DedustApi = DedustApi;
